import { Autocomplete, Divider, FormControl, FormControlLabel, Grid, ListItemIcon, ListItemText, Radio, RadioGroup, TextField, Typography, useMediaQuery } from '@mui/material';
import React, { useContext } from 'react';
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import popupStyle from "../../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss";
import chatbotStyles from "../../../../../../assets/styles/componentStyles/chatbot.module.scss";
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import contactStyles from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import workflowStyles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss"
import workflowFormStyles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss"
import GlobalButton from '../../../../../utility/globalButton/button';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import { customVariableDataInterface } from '../../../../../../models/axiosModel';
import { primaryColor } from '../../../../../../utils/colors';
import IconsColor from '../../../../../utility/iconsColor';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { filterAutocompleteOptionsWithException } from '../../../../../../utils/constants';


interface ResetVariablePopupProps {
    actionData: any, 
    stepAction: any, 
    setResetVariablePopup: React.Dispatch<React.SetStateAction<boolean>>,
    handleCancelClick: () => void,
} 

const ResetVariablePopup: React.FC<ResetVariablePopupProps> = (props) => {

    const { actionData, stepAction, setResetVariablePopup, handleCancelClick } = props;
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const setFlagUpdateFieldData = useFlowBuilderStore((state) => state.setFlagUpdateFieldData)
    const setExistingCustomVariablePayload = useFlowBuilderStore((state) => state.setExistingCustomVariablePayload)
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload)
    const setFlagDeleteData = useFlowBuilderStore((state) => state.setFlagDeleteData)
    

    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    const { onChangeCurrentActiveNodeConfig, nodes, onBlurOfFallBackOfBtnVar, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    

    const largeScreen = useMediaQuery('(max-width : 1600px) and (min-width : 0px)');

     const handleEditFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setFlagDataCollectionPopup(true);
        setFlagUpdateFieldData(true);
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
    }

    const handleDeleteFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
        if (setFlagDeleteData) {
            setFlagDeleteData(true)
        }
    }

    const renderOptions = (props: React.HTMLAttributes<HTMLLIElement>, option: any): React.ReactNode => {
        if (option.chatbot_custom_variable_configuration_id == "-1" && option.chatbot_custom_variable_name == "New Field") {
            return (
                <ul className={contactStyles.newTagNameUlElement}>
                    <Divider className={contactStyles.newTagDivider} />
                    <li {...props} style={{ minHeight: "auto", cursor: "pointer", padding: "10px 16px", display: "flex", alignItems: "center", gap: "5px", boxSizing: "border-box", outline: "none", color: primaryColor }} onClick={() => { setFlagDataCollectionPopup(true); }}>
                        <AddIcon />
                        <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>New Field</Typography>
                    </li>
                </ul>
            )
        }
        return (
            <li {...props} key={option.chatbot_custom_variable_configuration_id}>
                <Grid container>
                    <ListItemText primary={option.chatbot_custom_variable_name} className={styles.listItemsStyle} />
                </Grid>
                <Grid container justifyContent={"end"} sx={{ maxWidth: "60px" }}>
                    <Grid item onClick={(e) => e.stopPropagation()}>
                        <ListItemIcon onClick={(event) => handleEditFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}>
                            <EditIcon sx={{ height: "14px", width: "14px", fontSize: "14px" }} />
                        </ListItemIcon>
                    </Grid>
                    <Grid item onClick={(e) => e.stopPropagation()} paddingLeft={"12px"}>
                        <ListItemIcon onClick={(event) => handleDeleteFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}>
                            <IconsColor height="14" width="14" iconName="DeleteIcon" fillColor="#7A7A7A" />
                        </ListItemIcon>
                    </Grid>
                </Grid>
            </li>
        )
    } 

    const onChangeOfResetAllVariable = (resetAllVariables: boolean) => {
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, 
            {
                ...actionData, 
                flag_reset_all_variable: true, 
                flag_reset_all_custom_variable: resetAllVariables,
            }
            ,
            {
                updateType: "editExistingStepAction"
            }
        ); 
    } 

    const onChangeOfResetVariables = (value: customVariableDataInterface[] | null) => {
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, 
            {
                ...actionData, 
                flag_reset_variable: true, 
                reset_custom_variable: value ? value?.map((val) => {
                    return {
                        reset_custom_variable_id: val?.chatbot_custom_variable_configuration_id,
                    }
                }) : [],
            },
            {
                updateType: "editExistingStepAction"
            }
        ); 
    }

    const disabledSaveBtn = () => {
        if(!actionData?.flag_reset_all_custom_variable && actionData?.reset_custom_variable?.length == 0){
            return true;
        }   
        return false;
    }    

    const handleSaveClick = () => {
        onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { ...actionData, type: "saving_payload_key_changes_in_BE" },
            {
                updateType: "editExistingStepAction"
            }
        );  
        setResetVariablePopup(false);
    }

    return (
        <>
            <Grid container className={`${globalStyles.fullHeight} ${globalStyles.zIndex1} ${globalStyles.flexColumn}`} gap={"20px"} padding={"30px"} flexWrap={"nowrap"}>
                <Grid item className={`${globalStyles.fullwidth} ${globalStyles.textCenter}`}>
                    <span className={popupStyle.popupTitleStyle}>Reset Variable</span>
                </Grid>
                <Grid item>
                    <Divider className={workflowFormStyles.resetVariableDivider} />
                </Grid>

                <Grid item className={`${globalStyles.fullwidth}`}>
                    <Grid container gap={3}>
                        <Grid item xs={12}>
                            <Grid container direction={"column"} gap={1}>
                                <Grid item className={`${workflowFormStyles.fieldHeadingStyle} ${workflowFormStyles.resetVariableTitle}`}>Choose whether to reset all variables or specific ones.</Grid>
                                <Grid item>
                                    <FormControl>
                                        <RadioGroup
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue=""
                                            name="radio-buttons-group"
                                            value={actionData?.flag_reset_all_custom_variable}
                                            onChange={(event) => onChangeOfResetAllVariable(event.target.value == "true")}
                                        >
                                            <FormControlLabel className={globalStyles.radioLabelStyle} value={true} disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)} control={<Radio className={globalStyles.radioButton} />} label="Reset all variables" />
                                            <FormControlLabel className={globalStyles.radioLabelStyle} value={false} disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)} control={<Radio className={globalStyles.radioButton} />} label="Reset specific variables" />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                        {!actionData?.flag_reset_all_custom_variable && 
                            <Grid item xs={12}>
                                <Grid container gap={1}>
                                    <Grid item xs={12}>
                                        <Typography className={styles.createWorkflowLabelStyle}>Variable</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Autocomplete
                                            className={`${workflowStyles.resetVariableAutoComplete} ${globalStyles.fullwidth}`}
                                            multiple
                                            options={customVariableList?.custom_variable_data ? [...customVariableList?.custom_variable_data.filter((data) => data.flag_archived == false), {
                                                chatbot_custom_variable_configuration_id: "-1",
                                                chatbot_custom_variable_name: "New Field",
                                                chatbot_custom_variable_fallback_value: "",
                                                flag_archived: false
                                            }] : []}
                                            getOptionLabel={(option) => option?.chatbot_custom_variable_name || ""}
                                            filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "chatbot_custom_variable_name", "chatbot_custom_variable_configuration_id")}
                                            value={customVariableList?.custom_variable_data.filter((variable) => actionData?.reset_custom_variable?.find((customVar: any) => customVar?.reset_custom_variable_id == variable.chatbot_custom_variable_configuration_id)) || []}
                                            onChange={(_: React.SyntheticEvent, value: customVariableDataInterface[] | null) => onChangeOfResetVariables(value)}
                                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                            ListboxProps={{ style: { maxHeight: '150px', overflow: 'auto', paddingBottom: "50px" } }}
                                            renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: customVariableDataInterface) => { return renderOptions(props, option); }}
                                            renderInput={params => {
                                                const { InputProps, ...restParams } = params;
                                                const { startAdornment, ...restInputProps } = InputProps;
                                                return (
                                                    <TextField
                                                        {...restParams}
                                                        placeholder='Select Variables to Reset'
                                                        InputProps={{
                                                            ...restInputProps,
                                                            startAdornment: (
                                                                <div style={{
                                                                    maxHeight: "79px",
                                                                    overflowY: 'auto',
                                                                }}
                                                                >
                                                                    {startAdornment}
                                                                </div>
                                                            ),
                                                        }}
                                                    />
                                                );
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid>

                <Grid item className={`${globalStyles.fullwidth}`} mt={1}>
                    <Grid container direction={"row"} gap={2} justifyContent={"center"}>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Cancel"}
                                className='borderedButtonStyle'
                                sx={{ minWidth: "130px", fontSize: largeScreen ? "13px !important" : "" }} 
                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => {
                                    handleCancelClick();
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Save"}
                                className='primaryButtonStyle'
                                sx={{ minWidth: "130px" }}
                                disabled={disabledSaveBtn() || isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => {
                                    handleSaveClick();
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ResetVariablePopup
